
import thunk from 'redux-thunk';
import { 
  createStore as _createStore, 
  compose, 
  applyMiddleware, 
  combineReducers as _combineReducers 
} from 'redux';
import { Provider } from 'react-redux';

import { reducer as notificationSystemReducer } from 'react-notification-system-redux';

const createStoreWithThunk = compose(applyMiddleware(thunk))(_createStore);

export { Provider };


export const combineReducers = (reducers)=>
  _combineReducers({
    notifications: notificationSystemReducer,
    ...reducers
  });


export const createStore = (reducer, initialState)=>
  createStoreWithThunk(reducer, initialState);

